import React from 'react';
import PropTypes from 'prop-types';
import './checkbox.css';

/* Checkbox — one filter option in the browse rail (`.br-opt`).

   `disabled` and `count === 0` mean the same thing here: the reference disables
   options that would return nothing ("no dead ends"), so a caller with counts
   gets the behaviour by passing them and one without can pass `disabled`. A
   ticked option is never disabled, or clearing it would be impossible.

   The count is hidden by default (SP-main, 2026-09-03): on a curated shelf the
   counts make the catalogue look thin, and their warning job is already done by
   the disabled state. */
export default function Checkbox({
  label,
  checked,
  onChange,
  count,
  showCount,
  disabled,
  clamp,
  title,
  children,
  ...rest
}) {
  const dead = disabled || (count === 0 && !checked);

  return (
    <label
      className={[
        'br-opt',
        dead ? 'is-0' : '',
        checked ? 'is-on' : '',
      ].filter(Boolean).join(' ')}
    >
      <input
        type="checkbox"
        checked={!!checked}
        disabled={dead}
        onChange={(e) => onChange && onChange(e.target.checked, e)}
        {...rest}
      />
      <span
        className={clamp ? 'br-opt-clamp' : undefined}
        title={title || (clamp && typeof label === 'string' ? label : undefined)}
      >
        {label}
      </span>
      {showCount && typeof count === 'number' && <i className="n">{count}</i>}
      {children}
    </label>
  );
}

Checkbox.propTypes = {
  label: PropTypes.node.isRequired,
  checked: PropTypes.bool,
  /** Called with the new boolean, then the event. */
  onChange: PropTypes.func,
  /** Facet count. 0 disables the row unless it is already ticked. */
  count: PropTypes.number,
  /** Draw the count. Off by default — see the note above. */
  showCount: PropTypes.bool,
  disabled: PropTypes.bool,
  /** Truncate a long label to one line, with the full text as a tooltip. */
  clamp: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.node,
};
